import { render, staticRenderFns } from "./GeneralQuestions.vue?vue&type=template&id=f7b5f2de&scoped=true"
import script from "./GeneralQuestions.vue?vue&type=script&lang=js"
export * from "./GeneralQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b5f2de",
  null
  
)

export default component.exports